import { Route } from "@mapmycustomers/shared/types/entity";

import getRouteCheckedStopCount from "./getRouteCheckedStopCount";

const getRouteProgress = (route: Route): number => {
  const totalStops = route.items;
  if (totalStops === 0) {
    return 0;
  }
  return getRouteCheckedStopCount(route) / totalStops;
};

export default getRouteProgress;
